import { styled } from 'twin.macro'

export const StyledSocialList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
  margin: 0;

  li a {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.8125rem;
    font-weight: 400;
    color: var(--text-accent);
    text-decoration: none;
    padding: 0.375rem 0.875rem;
    background: var(--bg-card);
    border: 0.5px solid var(--border-color);
    border-radius: 980px;
    transition: all 0.3s var(--ease-spring);
    box-shadow: var(--shadow-sm);

    svg {
      font-size: 0.75rem;
      transition: transform 0.3s var(--ease-spring);
    }

    &:hover {
      box-shadow: var(--shadow-md);
      transform: translateY(-1px);
      svg {
        transform: scale(1.1);
      }
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }
`

export const StyledButton = styled.a``
